import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Buttons, FlexContainer, Inputs, Spinner, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import { routeStateSelector } from 'Store/modules/router/selectors';
import { setIsLoadingAction, setIsNotLoadingAction } from 'Store/modules/app/actions';
import { useFetchSatUserEfirma } from 'Containers/Datagathering/hooks';
import { useFetchSaveEfirmaMutation } from 'Containers/Account/components/AccountProfile/components/EFirmaForm/hooks';
import FormContainer from 'Components/UI/FormContainer';
import DocBox from 'Components/DocBox';
import { routes } from 'Constants/routes';
import { EfirmaType } from 'Types/common';
import model from './model.json';

const initialState = {
  certificate: '',
  privateKey: '',
  passphrase: '',
};

const EfirmaForm = (): JSX.Element => {
  const [formValues, setFormValues] = useState<EfirmaType>(initialState);
  const isPreviousYears = useSelector(routeStateSelector);
  const dispatch = useDispatch();
  const { isLoading, data } = useFetchSatUserEfirma(isPreviousYears);
  const setLoading = (): unknown => dispatch(setIsNotLoadingAction());
  const { mutate, data: efirma } = useFetchSaveEfirmaMutation(setLoading);
  const [isValidPasswordFormat, setIsValidPasswordFormar] = useState(true);
  const { t } = useTranslation(locizeNS.DG);

  const handleChange = (value: string, id: string): void => {
    setFormValues(prev => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleChangePassword = (value: string, id: string): void => {
    const isValid = /^.{8,256}$/.test(value);
    setIsValidPasswordFormar(isValid);
    handleChange(value, id);
  };
  const handleOnSubmit = (e: React.ChangeEvent): void => {
    e.preventDefault();
    mutate(formValues);
    dispatch(setIsLoadingAction());
  };

  useEffect(() => {
    if (efirma) {
      history.push(routes.DATAGATHERING_REFERRAL, {
        products: isPreviousYears?.products,
      });
    }
  }, [data, efirma]);
  if (isLoading) {
    return <Spinner size="L" justify="center" align="center" />;
  }

  return (
    <FormContainer onSubmit={handleOnSubmit}>
      <FlexContainer direction="column" gap="dimension_16">
        <Text type="headline" color="dark" size="XS_L_S">
          {t('DGEfirma.title')}
        </Text>
        {model.map(item => (
          <DocBox
            key={item.id}
            testID={item.testID}
            label={item.label}
            setValue={handleChange}
            aceptFiles={item.aceptFiles}
            id={item.id}
          />
        ))}
        <Inputs.Password
          type="password"
          label={t('DGEfirma.inputLabel')}
          placeholder={t('DGEfirma.input.placeholder')}
          hasError={!isValidPasswordFormat}
          errorMsg="La contraseña tiene un formato inválido"
          value={formValues.passphrase}
          onChange={val => handleChangePassword(val, 'passphrase')}
        />
        <Buttons.Classic
          size="l"
          type="submit"
          disabled={Object.values(formValues).includes('') || !isValidPasswordFormat}
          mode="primary"
          testID="btnSubmit"
          label={t('DGRfc.CTA')}
        />
        <Buttons.Classic
          size="l"
          onClick={() =>
            history.push(routes.DATAGATHERING_REFERRAL, {
              products: isPreviousYears?.products,
            })
          }
          type="button"
          mode="secondary"
          label={t('DG.ommit.CTA')}
        />
        <Text type="paragraphs" color="dark" size="XS_S_S" align="center">
          {t('DG.efirma.encription')}
        </Text>
      </FlexContainer>
    </FormContainer>
  );
};

export default EfirmaForm;
